
import Scene from "./scene";
import SceneFactory from "./scenefactory";


export default class SceneService 
{
   current:Scene | null = null;
   factory:SceneFactory | null = null;
   private activeSceneName: string | null = null;
   private readonly sceneListeners = new Set<() => void>();
   readonly subscribe = (listener: () => void): (() => void) => {
      this.sceneListeners.add(listener);
      return () => { this.sceneListeners.delete(listener); };
   };
   readonly getSnapshot = (): string | null => this.activeSceneName;
   readonly getServerSnapshot = (): null => null;

   private publishScene(name: string | null): void {
      if (this.activeSceneName === name) return;
      this.activeSceneName = name;
      for (const listener of this.sceneListeners) listener();
   }
   constructor()
   {

   }

   set_factory(factory:SceneFactory):void
   {
      this.factory = factory;
   }

  async activate(scene_name:string,canvas:HTMLCanvasElement)
  {
    if(this.current)
    {
        this.deactivate();
    }

    if(this.factory)
    {
         const scene= this.factory.make_scene(scene_name);
         if(scene)
         {
            this.current = scene;
            await scene.activate(canvas);
            // Do not show scene-specific controls until activation succeeds,
            // or republish an activation that was superseded while awaiting.
            if (this.current === scene) this.publishScene(scene_name);
         }
         else
         {
            console.log("SceneService: no scene for "+scene_name);
         }
    }
    else
    {
         console.log("SceneService: no scene factory");
    }

   
  }

   prepare(device: GPUDevice) {
    if (this.current) {
      this.current.prepare(device);
    }
  }

  deactivate()
  {
     if(this.current)
     {
        this.current.deactivate();
        this.current = null;
     }
     this.publishScene(null);
  }

  query_number(key: string): number | null
   {
     if(this.current)
     {

       return this.current.query_number(key);
     }
    return null;
}

   query_string(key: string): string| null
      {
      if(this.current)
      {

         return this.current.query_string(key);
      }
      return null;
   }


   query_bool(key: string): boolean | null
   {
     if(this.current)
     {

       return this.current.query_bool(key);
     }
      return null;
   }

   set_string(key: string, str:string): void
   {
      console.log("scene_service",str);
     if(this.current)
     {
        this.current.set_string(key,str);
     }

   }




   ui_message(cmd:string,msg:string)
   {
      if(this.current)
      {
         this.current.ui_message(cmd,msg);
      }
   }

     tick(delta_time: number)
     {
         if (this.current) 
         {
            this.current.tick(delta_time);
         }
     }

}
